import * as React from 'react';
import {
  ActionType,
  ParameterConfig,
  Attribute,
  ListAction,
  ValueSuggestionData,
  MessageTemplate
} from '@interface/index';
import { RESPONSE_CHANNEL_TYPE } from '@config/index';
import { Space, InputNumber, Modal } from 'antd';
import { NiInput, ReferenceTextArea, NiSelect, niConfirm, NiForm } from '@component/index';
import { cloneDeep } from 'lodash';
import '@page/intent/component/response.less';
import { localizedString } from '@locale/index';
import { FormattedMessage } from 'react-intl';
import { isEqual, ParameterMapStore, isStructAgent, getMessageTemplates } from '@lib/index';
import CodeTextArea from '@component/code-textarea/code-textarea';

export type ResponseCompProps = {
  suggestion?: ValueSuggestionData;
  data: { responseSequence: ListAction[] };
  bodyItTypeId?: string;
  options: any[];
  channel: string;
  selectedParameters: Attribute[];
  onUpdate: (responseSequence: any[]) => void;
  disabled?: boolean;
  inModal?: boolean;
};

export interface ResponseCompState {
  data: { responseSequence: ListAction[] };
  suggestions: ParameterConfig[];
  suggestionMap: { [key: string]: ParameterConfig };
}

export class ResponseComp extends React.Component<
  ResponseCompProps,
  ResponseCompState
> {

  constructor(props: ResponseCompProps) {
    super(props);

    this.state = {
      data: {
        responseSequence: []
      },
      suggestions: [],
      suggestionMap: {}
    };
  }

  componentDidMount() {
    this.onInit();
  }

  onInit = async () => {
    const props = this.props;
    const suggestions: ParameterConfig[] = [];
    const suggestionMap: { [key: string]: ParameterConfig } = {};

    if (Array.isArray(props.options)) {
      props.options.filter(Boolean).forEach((option: any) => {
        suggestionMap[option.id || ''] = option;
        suggestions.push(option);
      });
    }

    this.setState({
      suggestionMap,
      suggestions,
      data: props.data
    });
  }

  componentDidUpdate(prevProps: any) {
    if (!isEqual(prevProps.bodyItTypeId, this.props.bodyItTypeId) ||
      !isEqual(prevProps.data, this.props.data)) {
      this.onInit();
    }
  }

  render() {
    const { data } = this.state;

    const responseSequenceDom = [];

    for (const [i, response] of (
      (data && data.responseSequence) || []
    ).entries()) {
      responseSequenceDom.push(
        this.getTextListResponseDiv(i, response)
      );
    }

    return (
      <div className="response-comp-wrapper">
        {responseSequenceDom}
      </div>
    );
  }

  getTextListResponseDiv = (idx: number, response: ListAction) => {
    const state = this.state;
    const props = this.props;
    const { channel } = props;
    const { data } = this.state;

    if (!data) {
      return '';
    }

    const action = data.responseSequence[idx];

    return (
      <div
        className="response__wrap"
        key={`response-block-${ActionType.LIST}-${idx}`}
        style={{
          borderBottom: '1px solid #ccc', // 修改样式变量
          borderRadius: 5
        }}
      >
        <div className="response__title">
          <Space>
            <span key="number">
              <span className="response__title_num">
                <FormattedMessage id="text_list_action_count" />:
              </span>
              <InputNumber
                disabled={props.disabled}
                className="num_input"
                min={1}
                value={response.itemSize}
                onChange={(value: any) => {
                  this.handleUpdateListItemSize(idx, value || 0);
                }}
              />
            </span>
            <span style={{ marginLeft: 16, marginRight: 8 }}>{localizedString('list_reply_delimiter')}:</span>
            <NiInput
              disabled={props.disabled || isStructAgent()}
              key="single-delimiter"
              style={{ width: 60 }}
              value={action.delimiterField}
              placeholder={localizedString('list_reply_delimiter_field')}
              onChange={(e: any) => {
                this.setState(prevState => {
                  const target = cloneDeep(prevState.data);
                  target.responseSequence[idx].delimiterField = e.target.value;
                  return { data: target };
                }, () => {
                  this.props.onUpdate(this.state.data.responseSequence);
                });
              }}
            />
            <NiInput
              disabled={props.disabled || isStructAgent()}
              key="zero-delimiter"
              style={{ width: 60 }}
              value={action.delimiterEnd}
              placeholder={localizedString('list_reply_delimiter_end')}
              onChange={(e: any) => {
                this.setState(prevState => {
                  const target = cloneDeep(prevState.data);
                  target.responseSequence[idx].delimiterEnd = e.target.value;
                  return { data: target };
                }, () => {
                  this.props.onUpdate(this.state.data.responseSequence);
                });
              }}
            />
          </Space>
        </div>

        <NiForm
          style={{ margin: 8 }}
          direction="vertical"
          items={[
            {
              key: 'header',
              label: 'Header',
              content: (
                <CodeTextArea
                  dataId="header"
                  inModal={props.inModal}
                  disabled={props.disabled || isStructAgent()}
                  data={state.data.responseSequence[idx].header}
                  update={(next: string) => {
                    this.setState(prevState => {
                      const target = cloneDeep(prevState.data);
                      target.responseSequence[idx].header = next;
                      return { data: target };
                    }, () => {
                      this.props.onUpdate(this.state.data.responseSequence);
                    });
                  }}
                />
              )
            },
            {
              key: 'body',
              label: 'Body',
              content: (
                <CodeTextArea
                  dataId="body"
                  inModal={props.inModal}
                  disabled={props.disabled || isStructAgent()}
                  data={response.body}
                  update={(next: string) => {
                    this.setState(prevState => {
                      const target = cloneDeep(prevState.data);
                      target.responseSequence[idx].body = next;
                      return { data: target };
                    }, () => {
                      this.props.onUpdate(this.state.data.responseSequence);
                    });
                  }}
                />
              )
            },
            {
              key: 'footer',
              label: 'Footer',
              content: (
                <CodeTextArea
                  dataId="footer"
                  inModal={props.inModal}
                  disabled={props.disabled || isStructAgent()}
                  data={state.data.responseSequence[idx].footer}
                  update={(next: string) => {
                    this.setState(prevState => {
                      const target = cloneDeep(prevState.data);
                      target.responseSequence[idx].footer = next;
                      return { data: target };
                    }, () => {
                      this.props.onUpdate(this.state.data.responseSequence);
                    });
                  }}
                />
              )
            }
          ]}
        />
      </div>
    );
  };

  handleUpdateTextListResponse = (idx: number, resp: ListAction) => {
    this.setState(prevState => {
      const target = cloneDeep(prevState.data);
      target.responseSequence[idx] = resp;
      return { data: target };
    }, () => {
      this.props.onUpdate(this.state.data.responseSequence);
    });
  };

  handleUpdateListItemSize = (idx: number, size: number) => {
    this.setState(prevState => {
      const target = cloneDeep(prevState.data);
      target.responseSequence[idx].itemSize = size;
      return { data: target };
    }, () => {
      this.props.onUpdate(this.state.data.responseSequence);
    });
  };
}
